<div class="bg-white">
    <mat-card appearance="outlined">
        <div class="mainBody">
            <div class="one-column">
                <form onkeypress="return event.keyCode != 13;">
                    <div class="mainBody">
                        <p><strong>Login con trazabilidad</strong></p>
                        <hr>
                        <div class="flex-container-column">
                            <app-input inputType="text" placeholder="Usuario" name="userName"
                                [isRequired]="true" [(ngModel)]="userName"></app-input>
                            <mat-form-field class="w-100">
                                <mat-label>Contraseña</mat-label>
                                <mat-icon matPrefix class="iconoLogin">https</mat-icon>
                                <input matInput required [type]="showNewPassword ? 'text' : 'password'" #input
                                    placeholder="Contraseña" name="password" [(ngModel)]="password" minlength="1">
                                <mat-icon matSuffix (click)="showPassword(input)" class="click iconoLogin">
                                    {{showNewPassword ? 'visibility_off' : 'visibility'}}
                                </mat-icon>
                            </mat-form-field>
                        </div>
                        <div>
                            <ng-container *ngIf="loginSpinner">
                                <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
                            </ng-container>
                            <ng-container *ngIf="!loginSpinner"> 
                                <button style="background-color: white;" mat-stroked-button (click)="generarToken()">
                                    Generar
                                </button>
                            </ng-container>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </mat-card>
</div>